import React from 'react';
import logo from './logo.svg';
import './App.css';
import Layout from './Layout';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Button } from 'react-bootstrap';
import VideoPlayer from './VideoPlayer';
import Welcome from './Welcome';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VideoInfo from './VideoInfo';
import Login from './Login';
import Dashboard from './Dashboard';
import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
  Redirect
} from "react-router-dom";
import { withRouter } from "react-router";
import { LoginRequest, GetMenu } from "./Requests";
const queryString = require("query-string");

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      selectedVideo: null,
      showMenu: false,
      key: 0,
      urlVideoQuery: "",
      animation: "welcome",
      adminByQueryString: false,
      JWTToken: null,
      menu: null,
      filteredMenu: []
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.selectVideo = this.selectVideo.bind(this);
    this.allowAdmin = this.allowAdmin.bind(this);
    this.animateTransition = this.animateTransition.bind(this);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.setFilteredMenu = this.setFilteredMenu.bind(this);
    this.updateMenu = this.updateMenu.bind(this);
    this.findValuesHelper = this.findValuesHelper.bind(this);
    this.findVideos = this.findVideos.bind(this);
    this.setMenu = this.setMenu.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.selectVideo(null)
    }
  }

  setFilteredMenu = (items) => {
    let filteredMenu = items;
    this.setState({ filteredMenu });
  }

  updateMenu = (id, expanded) => {
    let menu = Object.assign([], this.state.menu);

    menu.forEach((level1) => {
      if (level1.children) {
        level1.children.forEach(level2 => {
          if (level1.id === id) {
            level1.expanded = expanded;
          }
          if (level2.id === id) {
            level2.expanded = expanded;
          }
        })
      }
    });

    this.setState({ menu });
  };

  findValuesHelper = (obj, key, findValue, list) => {
    if (!obj) return list;
    if (obj instanceof Array) {
      for (var i in obj) {
        list = list.concat(this.findValuesHelper(obj[i], key, findValue, []));
      }
      return list;
    }
    if (obj[key]) {
      let str = JSON.stringify(obj[key]);
      if (str === findValue) {
        list.push(obj);
      }
    }

    if ((typeof obj == "object") && (obj !== null)) {
      var children = Object.keys(obj);
      if (children.length > 0) {
        for (i = 0; i < children.length; i++) {
          list = list.concat(this.findValuesHelper(obj[children[i]], key, findValue, []));
        }
      }
    }
    return list;
  }

  findVideos = (obj, list) => {
    if (!obj) return list;
    if (obj instanceof Array) {
      for (var i in obj) {
        list = list.concat(this.findVideos(obj[i], []));
      }
      return list;
    }
    if (obj["video"]) {
      list.push(obj);
    }

    if ((typeof obj == "object") && (obj !== null)) {
      var children = Object.keys(obj);
      if (children.length > 0) {
        for (i = 0; i < children.length; i++) {
          list = list.concat(this.findVideos(obj[children[i]], []));
        }
      }
    }
    return list;
  }

  setMenu = (data) => {
    this.setState({ menu: data })
  }

  componentDidMount() {
    GetMenu()
      .then(response => {
        if (response.status === 200) {
          this.setMenu(response.data)
        } else {
          toast.dark("Ha ocurrido un error al obtener el menù");
        }
      })
      .catch(error => {
        toast.dark("Ha ocurrido un error al obtener el menù");
        console.error(error.message);
      })
    this.setState({ JWTToken: sessionStorage.getItem("JWTToken") }, () => {
      if (this.state.JWTToken) {
        this.animateTransition("welcome");
      }

      this.setState({ isMounted: true })
    });
  }

  toggleMenu = (state) => {
    let showMenu = state;
    this.setState({ showMenu });
  }

  allowAdmin = () => {
    this.setState({ adminByQueryString: true });
  }

  animateTransition = (animation) => {
    let key = this.state.key;
    key++;

    this.setState({ key, animation });
  }

  selectVideo = (video) => {
    this.toggleMenu(false);
    let selectedVideo = this.state.selectedVideo ? Object.assign({}, this.state.selectedVIdeo) : null;
    let key = this.state.key;

    if (video) {
      if (JSON.stringify(selectedVideo) !== JSON.stringify(video)) {
        this.setState({ selectedVideo: video, key },
          this.props.location.pathname !== process.env.PUBLIC_URL + "/watch/" + video.video.id ?
            () => this.props.history.push(process.env.PUBLIC_URL + "/watch/" + video.video.id)
            :
            () => { }
        );
      }
    } else {
      this.setState({ selectedVideo, key });
    }
  }

  login = async (data) => {
    LoginRequest(data.username, data.password)
      .then(response => {
        if (response.status === 200) {
          this.setState({ JWTToken: response.data }, () => { sessionStorage.setItem("JWTToken", this.state.JWTToken); toast.dark(response.message) })
        } else {
          toast.dark(response.message);
        }
      })
  }

  logout = async () => {
    this.setState({ JWTToken: null }, () => { sessionStorage.removeItem("JWTToken"); })
  }

  render() {
    const URLCatch = () => {
      let { id } = useParams();
      id = id.toLowerCase();

      if (id !== this.state.urlVideoQuery) {
        this.setState({ urlVideoQuery: id });
      }
      return "";
    }
    const { selectedVideo, showMenu, urlVideoQuery, adminByQueryString, animation, JWTToken } = this.state;
    return (
      <Layout JWTToken={JWTToken} updateMenu={this.updateMenu} menu={this.state.menu} filteredMenu={this.state.filteredMenu} setFilteredMenu={this.setFilteredMenu} animateTransition={this.animateTransition} adminByQueryString={adminByQueryString} allowAdmin={this.allowAdmin} selectVideo={this.selectVideo} urlVideoQuery={urlVideoQuery} showMenu={showMenu} selectedVideo={selectedVideo} toggleMenu={this.toggleMenu}>
        <TransitionGroup className="todo-list">
          <CSSTransition
            //key={this.state.key}
            key={0}
            timeout={0}
          //classNames={animation}
          >
            <Container fluid className="mt-3 basket">
              <Row className={!this.props.location.pathname.includes(process.env.PUBLIC_URL + "/watch") ? "justify-content-center" : ""}>
                <Switch>
                  {/*<Route path={process.env.PUBLIC_URL + "/:id"} children={<URLCatch />} />*/}
                  <Route path={process.env.PUBLIC_URL + "/404/"}>
                    <Redirect from="*" to="/" />
                  </Route>
                  <Route exact path={[process.env.PUBLIC_URL, process.env.PUBLIC_URL + "/welcome/"]}>
                    <Welcome toggleMenu={this.toggleMenu} />
                  </Route>
                  <Route path={process.env.PUBLIC_URL + "/watch/:id"}>
                    {
                      this.state.menu ?
                        <>
                          <VideoPlayer selectVideo={this.selectVideo} findVideos={this.findVideos} menu={this.state.menu} searchInMenu={this.findValuesHelper} selectedVideo={selectedVideo?.video} />
                          <Col className="player-info" xs={12} sm={12} md={12} lg={4} xl={4}>
                            {
                              this.state.selectedVideo && selectedVideo.video ?
                                <VideoInfo selectedVideo={selectedVideo.video} />
                                :
                                ""
                            }
                          </Col>
                        </> :
                        ""
                    }
                  </Route>
                  <Route path={process.env.PUBLIC_URL + "/admin/"}>
                    {
                      adminByQueryString || JWTToken ?
                        JWTToken ? <Dashboard setMenu={this.setMenu} JWTToken={JWTToken} logout={this.logout} /> : <Login login={this.login} />
                        :
                        this.state.isMounted ? <Redirect from="*" to={process.env.PUBLIC_URL + "/"} /> : ""
                    }
                  </Route>
                  <Redirect from="*" to='/entrenamiento/moodle/' />
                </Switch>
              </Row>
              <Row>
                <Col className="mt-4">
                  © 2020 Pupitres | WhatsApp: <a href="https://api.whatsapp.com/send?phone=50671901982&text=He%20visto%20el%20entrenamiento%20de%20Moodle.%20Estoy%20interesado%20en:%20&source=&data=&app_absent=">+506 7190 1982</a>
                </Col>
              </Row>
            </Container>
          </CSSTransition>
        </TransitionGroup>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <ToastContainer />
      </Layout>
    );
  }
}

export default withRouter(App);